import type { NormalizeFn } from "./NormalizeFn.js";

export const jsNormalize: NormalizeFn = (...input: string[]): string =>
	input
		.join(" ")
		.trim()
		.normalize("NFKD")
		.toLowerCase()
		// eslint-disable-next-line no-misleading-character-class
		.replace(/[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u0300-\u036f\u2018-\u201f]/gu, "");
